import styled from 'styled-components'

export const Text = styled.div`
  font-size: 20px;
  line-height: 32 px;
  color: rgba(50, 50, 93, 0.7);
`

export const RedirectText = styled.p`
  font-size: 14px;
  line-height: 20 px;
  color: rgba(107, 124, 147, 0.54);
`



// WEBPACK FOOTER //
// src/components/SignupComplete/styles.js